import { flow, pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { detailCodec } from './codec';
import {
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decodeId,
  decodeVersioned,
  fetchApi,
  setBody,
  Versioned,
} from '@/services/api';
import { addVersionForUpdate } from '../../request';
import { Schedule } from '@/entities/analytics-schedule';
import { intoSendable } from '@/services/api/resources/analytics-scheduler/transform';

const baseUrl = '/v2/analytics-schedules';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const create = (schedule: Schedule) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(intoSendable(schedule))),
  chain(fetchApi),
  chain(decodeId),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);

export const update = (id: number, schedule: Versioned<Schedule>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(schedule.version)),
  map(setBody(intoSendable(schedule.data))),
  chain(fetchApi),
);
